import { cx } from '@linaria/core';
import { homeCardDescription, homeCardHeader, homeCardTitle, homeCardTitleWrapper, homeCardWrapper } from './HomeCard.styles';
import { useConfigureHome } from '../context';

type HomeCardProps = {
  title?: string;
  children: React.ReactNode;
  description?: string;
  action?: React.ReactNode;
};

export function HomeCard(props: HomeCardProps) {
  const { isAnimating } = useConfigureHome();
  const showHeader = props.title || props.description;
  return (
    <div
      className={cx(homeCardWrapper, !showHeader && 'no-gap')}
      style={{
        opacity: isAnimating ? 0 : 1,
        transition: 'opacity 0.2s',
      }}
    >
      <div className={homeCardHeader}>
        {showHeader && (
          <div className={homeCardTitleWrapper}>
            {props.title && <h2 className={homeCardTitle}>{props.title}</h2>}
            {props.description && <p className={homeCardDescription}>{props.description}</p>}
          </div>
        )}
        {props.action && <>{props.action}</>}
      </div>
      {props.children}
    </div>
  );
}
